import { calculation, numConvert } from "../../../../method";
import Echarts from "echarts";
import moment from "moment";
import { chineseNewYear } from "@/method/data";
const color = ['#4c9bf2', '#4AC18E', '#D9534F', '#67A8E4'];
// 春节日期维护
export const SPR = {
    ...chineseNewYear
};

export function compute(data, lastYearData, date, sprData = []) {
    const listName = ['ava', 'sold', 'revpar', 'rev', 'total'];
    listName.forEach(name => {
        data[32][name] = data.reduce((a, b, i) => a += i < 31 ? numConvert(b[name]) : 0, 0).toFixed(4);
    });
    data.forEach((item, i) => {
        data[i].revper = calculation(item.rev, item.total, 4);
        data[i].occ = calculation(item.sold, item.ava, 4);
        data[i].adr = calculation(item.rev, item.sold, 2);
        data[i].revpar = calculation(item.rev, item.ava, 2);
    });
    setKarte({
        data: [data.map(x => (x.occ * 100).toFixed(2)).slice(0, 31), lastYearData.map(x => (x.occ * 100).toFixed(2)).slice(0, 31)],

        name: "Occ%",
        id: 'chartOcc',
    });
    setKarte({
        data: [data.map(x => x.adr).slice(0, 31), lastYearData.map(x => numConvert(x.adr).toFixed(2)).slice(0, 31)],
        name: "ADR",
        id: 'chartAdr',
    });
    setKarte({
        data: [data.map(x => x.revpar).slice(0, 31), lastYearData.map(x => numConvert(x.revpar).toFixed(2)).slice(0, 31)],
        name: "RevPAR",
        id: 'chartRevpar',
    });
    setKarte({
        data: [data.map(x => numConvert(x.rev).toFixed(2)).slice(0, 31), lastYearData.map(x => numConvert(x.rev).toFixed(2)).slice(0, 31)],
        name: "Room Revenue",
        id: 'chartRoomRev',
    });
    if (moment(date).format('M') == 5 || moment(date).format('M') == 10) {
        // 五一
        setKarte({
            data: [data.map(x => (x.occ * 100).toFixed(2)).slice(0, 7), lastYearData.map(x => (x.occ * 100).toFixed(2)).slice(0, 7)],
            name: "Occ%",
            dataY: data.slice(0, 7).map(x => x.name),
            id: 'chartHolidayOcc',
        });
        setKarte({
            data: [data.map(x => x.adr).slice(0, 7), lastYearData.map(x => numConvert(x.adr).toFixed(2)).slice(0, 7)],
            name: "ADR",
            dataY: data.slice(0, 7).map(x => x.name),
            id: 'chartHolidayAdr',
        });
        setKarte({
            data: [data.map(x => x.revpar).slice(0, 7), lastYearData.map(x => numConvert(x.revpar).toFixed(2)).slice(0, 7)],
            name: "RevPAR",
            dataY: data.slice(0, 7).map(x => x.name),
            id: 'chartHolidayRevpar',
        });
        setKarte({
            data: [data.map(x => numConvert(x.rev).toFixed(2)).slice(0, 7), lastYearData.map(x => numConvert(x.rev).toFixed(2)).slice(0, 7)],
            name: "Room Revenue",
            dataY: data.slice(0, 7).map(x => x.name),
            id: 'chartHolidayRoomRev',
        });
    }
    if (SPR[moment(date).format('Y')].m == moment(date).format('M')) {
        // 春节
        const index = SPR[moment(date).format('Y')].d - 1;
        const lastIndex = SPR[moment(date).subtract(1, 'year').format('Y')].d - 1;
        setKarte({
            data: [data.map(x => (x.occ * 100).toFixed(2)).slice(index, index + 7), sprData.map(x => (x.occ * 100).toFixed(2)).slice(lastIndex, lastIndex + 7)],
            name: "Occ%",
            dataY: ['除夕', '初一', '初二', '初三', '初四', '初五', '初六'],
            id: 'chartHolidayOcc',
        });
        setKarte({
            data: [data.map(x => x.adr).slice(index, index + 7), sprData.map(x => numConvert(x.adr).toFixed(2)).slice(lastIndex, lastIndex + 7)],
            name: "ADR",
            dataY: ['除夕', '初一', '初二', '初三', '初四', '初五', '初六'],
            id: 'chartHolidayAdr',
        });

        setKarte({
            data: [data.map(x => x.revpar).slice(index, index + 7), sprData.map(x => numConvert(x.revpar).toFixed(2)).slice(lastIndex, lastIndex + 7)],
            name: "RevPAR",
            dataY: ['除夕', '初一', '初二', '初三', '初四', '初五', '初六'],
            id: 'chartHolidayRevpar',
        });
        setKarte({
            data: [data.map(x => numConvert(x.rev).toFixed(2)).slice(index, index + 7), sprData.map(x => numConvert(x.rev).toFixed(2)).slice(lastIndex, lastIndex + 7)],
            name: "Room Revenue",
            dataY: ['除夕', '初一', '初二', '初三', '初四', '初五', '初六'],
            id: 'chartHolidayRoomRev',
        });
    }
    return data
}

export const setKarte = ({
    data,
    name,
    dataY,
    id,
    dataX
}, isOnResize) => {
    var myChart = Echarts.init(document.getElementById(id));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        title: {
            text: name,
            textStyle: {
                align: 'left',
                color: '#333',
                fontSize: 20,
            },
            top: '5%',
            left: 'left',
        },
        legend: {
            top: '30',
            data: ['this year', 'last year']
        },
        color,
        xAxis: {
            splitLine: {
                lineStyle: {
                    show: true,
                }
            },
            "axisLabel": {
                textStyle: {
                    fontSize: 12,
                    color: '#000'
                },
            },
            data: dataY || new Array(31).fill(1).map((x, i) => i + 1),
        },
        yAxis: {
            name: name == 'Occ%' ? '%' : '',
            type: 'value'
        },
        tooltip: {
            trigger: 'axis',
            // formatter: `{b}日<br/>{a} : {c}${name == 'Occ%' ? '%' : ''}` 
        },
        toolbox: {
            id,
            right: 20,
            feature: {
                saveAsImage: {
                    type: 'png',//	设置图片格式 png或者'jpeg
                    name,
                    backgroundColor: '#FFF',
                    excludeComponents: ['toolbox'],
                    show: true,
                    title: '保存图片',
                    // icon: ...,
                }
            }
        },
        series: [{
            name: "this year",
            type: 'line',
            data: data[0],
        }, {
            name: "last year",
            type: 'line',
            data: data[1],
        }]
    };

    myChart.setOption(option);
}

export function computeYear(data, lastYearData) {
    data = data.map(x => ({ ...x }));
    lastYearData = lastYearData.map(x => ({ ...x }));
    const listName = ['ava', 'sold', 'revpar', 'rev', 'total'];
    listName.forEach(name => {
        data[12][name] = data.reduce((a, b, i) => a += i < 12 ? numConvert(b[name]) : 0, 0).toFixed(4);
    });
    data.forEach((item, i) => {
        if (i < 12) {
            data[i].name = `${i + 1}月`
        }
        data[i].revper = calculation(item.rev, item.total, 4);
        data[i].occ = calculation(item.sold, item.ava, 4);
        data[i].adr = calculation(item.rev, item.sold, 2);
        data[i].revpar = calculation(item.rev, item.ava, 2);
    });
    const dataX = new Array(12).fill(1).map((x, i) => `${i + 1}月`)
    setKarte({
        data: [data.map(x => (x.occ * 100).toFixed(2)).slice(0, 12), lastYearData.map(x => (x.occ * 100).toFixed(2)).slice(0, 12)],
        dataY: dataX,
        name: "Occ%",
        id: 'chartOcc',
    });
    setKarte({
        data: [data.map(x => x.adr).slice(0, 12), lastYearData.map(x => numConvert(x.adr).toFixed(2)).slice(0, 12)],
        name: "ADR",
        dataY: dataX,
        id: 'chartAdr',
    });
    setKarte({
        data: [data.map(x => x.revpar).slice(0, 12), lastYearData.map(x => numConvert(x.revpar).toFixed(2)).slice(0, 12)],
        name: "RevPAR",
        dataY: dataX,
        id: 'chartRevpar',
    });
    setKarte({
        data: [data.map(x => numConvert(x.rev).toFixed(2)).slice(0, 12), lastYearData.map(x => numConvert(x.rev).toFixed(2)).slice(0, 12)],
        name: "Room Revenue",
        id: 'chartRoomRev',
        dataY: dataX,
    });
    return data
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/compute.js